"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelPropTypes = exports.LabelGroupPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LabelPropTypes = exports.LabelPropTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].element]),
  subLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].element]),
  footnote: _propTypes["default"].bool,
  footnoteLocation: _propTypes["default"].string,
  tooltip: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].element]),
  variantOption: _propTypes["default"].bool,
  dynamicVariant: _propTypes["default"].bool,
  dynamicVariantValue: _propTypes["default"].string,
  benefitLimit: _propTypes["default"].string,
  popup: _propTypes["default"].shape({
    location: _propTypes["default"].string,
    link: _propTypes["default"].shape({
      label: _propTypes["default"].string,
      cssClass: _propTypes["default"].string
    })
  }),
  valueType: _propTypes["default"].oneOf(['radios', 'yesNoBoolean', 'limit', 'customFormat', 'custom_waitingPeriods', 'dynamicLimit', 'valueNoteOnly']),
  valueFields: _propTypes["default"].arrayOf(_propTypes["default"].string),
  valueMap: _propTypes["default"].shape({
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].element]),
    value: _propTypes["default"].string
  }),
  formatters: _propTypes["default"].shape({
    label: _propTypes["default"].func,
    value: _propTypes["default"].func
  })
};
var LabelGroupPropTypes = exports.LabelGroupPropTypes = {
  groupStyle: _propTypes["default"].oneOf(['fixed', 'showAll', 'showAllFullSpan', 'accordion', 'cards']),
  groupIsVisible: _propTypes["default"].bool,
  groupLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  items: _propTypes["default"].object
};